import React from 'react';
import PropTypes from 'prop-types';
import FacebookProvider, { Like } from 'react-facebook';

const FacebookLikeButton = ({ appId, url }) => (
  <FacebookProvider appId={appId}>
    <Like
      href={url}
      layout="button_count"
      size="small"
    />
  </FacebookProvider>
);

FacebookLikeButton.propTypes = {
  appId: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
};

export default FacebookLikeButton;



// WEBPACK FOOTER //
// ./src/app/components/facebook_like_button/index.js